"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var eth_sig_util_1 = require("eth-sig-util");

var address_1 = require("./address");

var buffer_1 = require("./buffer");

function signTypedMessage(message, privateKey) {
  return eth_sig_util_1.signTypedData_v4(buffer_1.toBuffer(privateKey), {
    data: JSON.parse(message)
  });
}

exports.signTypedMessage = signTypedMessage;

function recoverAddressFromTypedMessage(data, signature) {
  var address = eth_sig_util_1.recoverTypedSignature_v4({
    data: JSON.parse(data),
    sig: signature
  });
  return address_1.toChecksumAddress(address);
}

exports.recoverAddressFromTypedMessage = recoverAddressFromTypedMessage;